import { connect } from "react-redux";
import flowRight from "lodash.flowright";
import { clearFields } from "redux-form";
import get from "lodash.get";

//Constants
import {
  rulesEvaluationTypes,
  reduxFormNames,
  analyticsEventNames
} from "src/constants";

//HOC
import { withResourceLoaderFactory } from "src/hoc/factories";
import { withLoadingComponentFactory } from "src/hoc/factories";

//Components
import { WoundAlertRuleFormComponent } from "src/components/forms/wound_alert_rule_form_component";

//Action
import {
  postAlertAction,
  patchAlertAction,
  loadCustomRolesActionForRuleForm,
  loadRuleTemplatesAction
} from "src/actions/data_actions";

//Selectors
import {
  createAlertRuleFormInitialValuesSelector,
  createAlertRuleTemplatesForEvaluationTypeSelector,
  createAlertRuleFormFacilitiesByOrganizationSelector,
  createAlertRuleFormRoleOptionsSelector,
  organizationsForSelectedPartnerIdSelector
} from "src/selectors/section_selectors/admin";

import {
  customRolesResourceSelectors,
  ruleTemplatesResourceSelector,
  rulesResourceSelectors
} from "src/selectors/data_selectors";

import { customRolesContextSelector } from "src/selectors/context_selectors/custom_roles";
import { customRolesQuerySelector } from "src/selectors/query_selectors/admin";

import { createRuleTemplatesQuerySelector } from "src/selectors/api_selectors/admin/rule_templates";

function mapStateToProps(state, ownProps) {
  return {
    evaluationType: rulesEvaluationTypes.wound,
    initialValues: createAlertRuleFormInitialValuesSelector({
      rule: ownProps.rule,
      evaluationType: rulesEvaluationTypes.wound
    })(state),
    templates: createAlertRuleTemplatesForEvaluationTypeSelector(
      rulesEvaluationTypes.wound
    )(state),
    customRoles: createAlertRuleFormRoleOptionsSelector(
      reduxFormNames.woundAlertRuleForm
    )(state),
    rule: rulesResourceSelectors.createDataForIdSelector(
      get(ownProps, "rule.id")
    )(state),
    organizations: organizationsForSelectedPartnerIdSelector(state),
    facilities: createAlertRuleFormFacilitiesByOrganizationSelector(
      reduxFormNames.woundAlertRuleForm
    )(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendPostAlertAction(payload) {
      return dispatch(postAlertAction({ payload }));
    },
    sendPatchAlertAction(payload) {
      return dispatch(patchAlertAction({ payload }));
    },
    clearFields(...fieldNames) {
      dispatch(
        clearFields(
          reduxFormNames.woundAlertRuleForm,
          false,
          false,
          ...fieldNames
        )
      );
    }
  };
}

export const WoundAlertRuleFormContainer = flowRight(
  withResourceLoaderFactory({
    getResourceAction: loadRuleTemplatesAction,
    resourceSelectors: ruleTemplatesResourceSelector,
    createContextSelector: createRuleTemplatesQuerySelector,
    createQuerySelector: createRuleTemplatesQuerySelector
  }),
  withResourceLoaderFactory({
    getResourceAction: loadCustomRolesActionForRuleForm,
    resourceSelectors: customRolesResourceSelectors,
    createContextSelector: customRolesContextSelector,
    createQuerySelector: customRolesQuerySelector
  }),
  withLoadingComponentFactory({
    analyticsEventName: analyticsEventNames.renderWoundAlertRuleForm
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(WoundAlertRuleFormComponent);
